export default __webpack_public_path__ + "static/media/pin.606b871f.svg";